import { ApartmentListItemProps } from 'components/apartment-list-item';
import { APIFilterNotificationItem, EAvailabilityStatus, MarketTypes } from '../types';
import useOnRealtorsListPaginatedData from './use-on-realtors-list-paginated';

export type APIApartmentNotificationRes = {
  items: APIFilterNotificationItem[];
  count: number;
};

export type FavoritesFacilityList = Omit<ApartmentListItemProps, 'className' | 'icon'> & {
  apartmentComplexTitle: string;
  areaInSqM: number;
  attachment: string;
  availabilityStatus: { key: EAvailabilityStatus; translation: string };
  facilityStatus: { key: EAvailabilityStatus; translation: string };
  buildingTitle: string;
  floor: number;
  floorCount: number;
  id: number;
  marketType: MarketTypes;
  minorOwners: boolean;
  price: number;
  pricePerSqM: number;
  roomCount: number;
  rejectedByClient?: boolean;
  title: string;
  hasNote: boolean;
};

const useFavoritesList = (id: number) => {
  const result = useOnRealtorsListPaginatedData<APIApartmentNotificationRes, FavoritesFacilityList>(
    `/favourites/list/${id}`,
    'post',
    // @ts-ignore
    ({ facility, count }) => {
      return { facility: facility, count };
    },
    {},
  );

  return result;
};

export default useFavoritesList;
